import React from 'react';
import { Text } from '@chakra-ui/react';

/**
 * TitleComponent dynamically renders titles with configurable styles.
 * @param {string} content - The text content of the title.
 * @param {string} variant - The typography variant (e.g., "t1", "t2").
 * @param {string} ariaLabel - Accessibility label for the title.
 * @param {string} role - Accessibility role for the title.
 */
const TitleComponent = ({
  content,
  variant = 'headline-md-max',
  role = 'heading',
  ariaLabel,
  color,
  marginBottom
}) => {
  return (
    <Text
      as={role === 'heading' ? 'h1' : 'p'}
      role={role}
      aria-label={ariaLabel}
      fontFamily={`var(--${variant}-font-family, sans-serif)`}
      fontWeight={`var(--${variant}-font-weight, bold)`}
      fontSize={`var(--${variant}-font-size, 24px)`}
      lineHeight={`var(--${variant}-line-height, 1.5)`}
      letterSpacing={`var(--${variant}-letter-spacing, normal)`}
      color={color || `var(--${variant}-color, var(--sutter-sync-purple))`}
      textAlign={`var(--${variant}-text-align, left)`}
      textDecoration={`var(--${variant}-text-decoration, none)`}
      mb={marginBottom || 2}
    >
      {content}
    </Text>
  );
};

export default TitleComponent;
